import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import React, { PropsWithChildren } from 'react'
import Checkbox from 'core/elements/input/Checkbox'
import Theme from 'core/themes/model'
import generateTestId from 'utils/test-helpers'

interface DropdownItemProps {
  isSelected?: boolean
  showCheckbox?: boolean
  onClick: () => void
  disabled?: boolean
  disableCheckbox?: boolean
  title?: string
  index?: number
}

const useStyles = makeStyles<Theme>((theme) => ({
  dropdownItem: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    width: '100%',
    cursor: 'pointer',
    border: 'none',
    padding: theme.spacing(0.5, 1),
    fontSize: 14,
    background: null,
    '&:hover': {
      background: theme.components.dropdown.selectedBackground,
    },
    '& > .checkbox': {
      marginRight: 8,
    },
    '& > span': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
  },
  dropdownItemDisabled: {
    cursor: 'not-allowed',
    color: theme.palette.grey[300],
  },
  dropdownItemSelected: {
    background: theme.components.dropdown.selectedBackground,
  },
}))

export default React.forwardRef<HTMLLIElement, PropsWithChildren<DropdownItemProps>>(
  (props, ref) => {
    const classes = useStyles()
    const { children, isSelected, showCheckbox, disableCheckbox, index, disabled, ...rest } = props
    return (
      <li
        data-testid={generateTestId(index, 'dropdown', 'item')}
        ref={ref}
        className={clsx(classes.dropdownItem, {
          [classes.dropdownItemDisabled]: disabled,
          [classes.dropdownItemSelected]: isSelected && !showCheckbox,
        })}
        {...rest}
      >
        {showCheckbox ? <Checkbox disabled={disableCheckbox} checked={isSelected} /> : null}
        {children}
      </li>
    )
  },
)
